import { Card, CardProps } from "@mui/material";
import React, { ReactNode } from "react";

type OutlineCardProps = {
  children: ReactNode;
  background?: string;
} & CardProps;

const OutlineCard: React.FC<OutlineCardProps> = ({
  children,
  background,
  ...others
}) => (
  <Card
    sx={{
      height: (others?.sx as any)?.height ?? "auto",
      padding: (others?.sx as any)?.padding ?? "10px 10px",
      borderRadius: "5px",
      ...others?.sx,
    }}
    variant={others?.variant ?? "outlined"}
    {...(others?.sx ? undefined : others)}
  >
    {children}
  </Card>
);

export default OutlineCard;
